import React, { useState } from "react";
import TestnameInput from "../testing/TestnameInput";
import ActiveSubstanceInput from "./ActiveSubstanceInput";
import SubstanceInput from "./SubstanceInput";
import GbResidueInput from "./GbResidueInput";
import Button from "../Button";
import { normalPost } from "../../lib/Fetching";

export default function SubstanceMappingForm() {
  const [testname, setTestname] = useState(null);
  const [activeSubstance, setActiveSubstance] = useState(null);
  const [substance, setSubstance] = useState(null);
  const [gbResidue, setGbResidue] = useState(null);

  const handleSubmit = () => {
    normalPost("/mrls/substance_mappings", {
      test_name_id: testname && testname.value,
      active_substance_id: activeSubstance && activeSubstance.value,
      substance_id: substance && substance.value,
      gb_residue_id: gbResidue && gbResidue.value,
    });
  };

  return (
    <div>
      <div className="row">
        <div className="col-md-3">
          <label>Lims Test Name</label>
          <TestnameInput onChange={setTestname} hideInternal />
        </div>
        <div className="col-md-3">
          <label>EU Active Substance</label>
          <ActiveSubstanceInput onChange={setActiveSubstance} />
        </div>
        <div className="col-md-3">
          <label>EU MRL Residue</label>
          <SubstanceInput onChange={setSubstance} />
        </div>
        <div className="col-md-3">
          <label>GB MRL Residue</label>
          <GbResidueInput onChange={setGbResidue} />
        </div>
      </div>
      <br />
      <div className="row">
        <div className="col-md-4">
          <Button title="Create Entry" primary onClick={handleSubmit} />
        </div>
      </div>
    </div>
  );
}
